module.exports = __webpack_public_path__ + "static/media/info-circle.d4c70e13.svg";